import React, { Component } from "react";
import BsyTableContainer from "../BsyTableContainer";
import "./index.css";
import BsyAlert from "../BsyAlert";

export default class Dlg extends Component {
  static defaultProps = {
    hasHeader: true,
    hasFooter: false,
    customCls: "",
  };
  constructor(props) {
    super(props);
    this.state = {};
  }

  closeAlter = () => {
    if (this.props.onClose) {
      // 如果onClose返回false，则不关闭
      if (this.props.onClose() === false) {
        return;
      }
    }
    this.props.onRemoveRoot();
  };

  close = () => {
    if (this.props.onClose) {
      // 如果onClose返回false，则不关闭
      if (this.props.onClose() === false) {
        return;
      }
    }
    this.props.onRemoveRoot();
  };

  closeAlterMyApp = () => {
    this.props.onRemoveRoot();
  };
  _renderContent() {
    if (this.props.onContentCreate) {
      return this.props.onContentCreate(this);
    } else {
      return <BsyTableContainer attr={this.props.contentWidget} />;
    }
  }

  onCancelClick = () => {
    if (this.props.onCancel) {
      if (this.props.onCancel() === false) {
        return;
      }
    }
    this.closeAlter();
  };

  onCustomClick = () => {
    if (this.props.onCustom) {
      if (this.props.onCustom() === false) {
        return;
      }
    }
    this.closeAlter();
  };

  onOkClick = () => {
    if (this.props.onOk) {
      if (this.props.onOk() === false) {
        return;
      }
    }
    this.closeAlter();
  };

  _renderHeaderMenu() {
    if (this.props.onHeaderMenu) {
      return this.props.onHeaderMenu(this);
    } else {
      return "";
    }
  }

  _renderFooter() {
    if (this.props.onFooter) {
      return this.props.onFooter(this);
    } else {
      return "";
    }
  }

  render() {
    const { title, hasHeader, customCls, hasFooter } = this.props;
    return (
      <div className={"slider-body " + customCls}>
        {hasHeader && (
          <div className="slider-header">
            <span className="title">{title}</span>
            {this._renderHeaderMenu()}
            {this.props.hasCloseIcon === false ? (
              ""
            ) : (
              <div className="slider-close" onClick={this.closeAlter}>
                <i className="icon-close-large" />
              </div>
            )}
          </div>
        )}

        <div
          className="slider-main"
          style={{
            top: hasHeader ? "50px" : "0",
            bottom: hasFooter ? "50px" : "0",
          }}
        >
          {this._renderContent()}
        </div>

        {hasFooter ? (
          <div className="slider-footer">{this._renderFooter()}</div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
